<template>
    <div
      v-if="isOpen"
      class="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50"
    >
      <div class="bg-white p-6 rounded shadow-lg w-96">
        <h2 class="text-xl font-semibold mb-4">Agregar Nuevo </h2>
  
        <form @submit.prevent="handleSubmit">
          <div class="mb-4">
                <label for="name" class="block text-sm font-medium text-gray-700">
                Nombre
                </label>
                <input
                v-model="form.name_character"
                id="name"
                type="text"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                required
                />
            </div>
            <div class="mb-4">
            <select
                v-model="type_movement_id"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                placeholder="Selecciona una opción"
            >
                <option value="" disabled>Selecciona una opción</option>
                <option value="Todo">Todo</option>  <!-- Opción para "Todo" -->
                <option
                v-for="movement in dic_movements"
                :key="movement.value"
                :value="movement.name"  
                >
                {{ movement.name }}
                </option>
            </select>
            </div>
  
          <div class="mb-4">
            <label for="icon_svg" class="block text-sm font-medium text-gray-700">
              Ícono SVG
            </label>
            <textarea
              v-model="form.icon_svg"
              id="icon_svg"
              rows="3"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              required
            ></textarea>
          </div>
  
          <div class="flex justify-end">
            <button
              type="button"
              @click="close"
              class="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded mr-2"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script setup>
    import { ref, defineEmits, defineProps, onMounted } from "vue";
    import axios from "axios";
    import { useStore } from "vuex";
    
    defineProps({
        isOpen: {
        type: Boolean,
        required: true,
        },
    });
    
    const store = useStore();
    const emits = defineEmits(["close", "submit"]);
    
    const dic_movements = ref([]);
    const form = ref({
        name_character: "",
        icon_svg: "",
    });
    
    const type_movement_id = ref("");
    
    function close() {
        emits("close");
        form.value = {  name_character: "", icon_svg: "" };
    }
    
    function handleSubmit() {
        const dataToSubmit = {
            ...form.value,
            type_movement: type_movement_id.value,  // Agregar el tipo de movimiento
        };
        console.log(dataToSubmit)
        emits("submit", dataToSubmit);  // Enviar los datos con el tipo de movimiento
        close();
    }
    
    async function getDicTypeMovement() {
        let url = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_movement_property`;
        let options = {
        headers: {
            "Content-Type": "application/json",
        },
        };
    
        try {
        const response = await axios.get(url, options);
    
        if (response.status === 401) {
            store.dispatch("clearUserSession");
        }
    
        if (response.status === 200) {
            const formattedData = response.data.resp.map((item) => ({
            value: item.id,
            name: item.name,
            }));
            dic_movements.value = formattedData;
        }
        } catch (error) {
        console.error("Error al obtener el catálogo de tipo de movimiento:", error);
        }
    }
    
    onMounted(async () => {
        await getDicTypeMovement();
    });
  </script>